<template>
  <b-overlay :show="loading"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm">
    <validation-observer #default="{ handleSubmit }"
      ref="refFormObserver">
      <b-form class="scheduleForm"
        @submit.prevent="handleSubmit(onSubmit)"
        @reset.prevent="resetForm">
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="card">
              <div class="card-body p-1">
                <validation-provider #default="validationContext"
                  name="Ngày phát"
                  rules="required">
                  <b-form-group label="Ngày phát"
                    class="mb-0">
                    <template #label>
                      <label class="d-block font-weight-bolder">Ngày phát <span class="text-danger">*</span></label>
                    </template>
                    <flat-pickr v-model="frmData.date_play"
                      class="form-control"
                      :config="config_time"
                      placeholder="yyyy-mm-dd" />
                  </b-form-group>
                </validation-provider>
                <validation-provider #default="validationContext"
                  name="Chương trình"
                  rules="required">
                  <b-form-group label="Chương trình"
                    class="mt-1"
                    label-for="v-name">
                    <template #label>
                      <label class="d-block font-weight-bolder">Chương trình <span class="text-danger">*</span></label>
                    </template>
                    <b-form-input id="v-name"
                      v-model="frmData.name"
                      autofocus
                      :state="getValidationState(validationContext)"
                      placeholder="Chương trình" />
                    <b-form-invalid-feedback> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
                <validation-provider #default="validationContext"
                  name="Kênh"
                  rules="required">
                  <b-form-group>
                    <template #label>
                      <label class="d-block font-weight-bolder">Kênh <span class="text-danger">*</span></label>
                    </template>
                    <v-select v-model="frmData.channel_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="dataChannel"
                      label="name"
                      :reduce="(val) => val.id"
                      :state="getValidationState(validationContext)"
                      placeholder="--Chọn--" />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)"> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
                <b-col cols="12">
                  <b-form-group>
                    <b-form-checkbox id="v-status"
                      v-model="frmData.status"
                      value="1"> {{ $t('Kích hoạt') }} </b-form-checkbox>
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-button type="submit"
                    variant="primary"
                    class="mr-1 mt-1">
                    <feather-icon icon="SaveIcon" /> {{ $t('Save') }} </b-button>
                </b-col>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-8">
            <div class="card">
              <div class="card-body p-0">
                <b-table class="position-relative"
                  :items="itemsData"
                  responsive
                  :fields="tableColumns"
                  primary-key="id"
                  show-empty
                  empty-text="Không tìm thấy kết quả">
                  <template #cell(programFrames)="data">
                    <ul>
                      <li v-for="(val, index) in data.item.programFrames"
                        :key="index">
                        <span @click="showView(val)">{{ val.programName }} ({{ val.duration }}) </span>
                      </li>
                    </ul>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </validation-observer>
    <b-modal id="modalView"
      no-close-on-backdrop
      hide-footer
      size="lg"
      :title="modal_title"
      @close="hidenView">
      <schedule-view :item-view="itemView" />
    </b-modal>
  </b-overlay>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  required, min, max,
} from '@validations';
import {
  BCard, BAlert, BOverlay, BTable, BLink, BButton, BRow, BCol, BForm, BFormInput, BFormInvalidFeedback, BFormTextarea, BFormCheckbox, BFormGroup,
} from 'bootstrap-vue';
import { ref } from '@vue/composition-api';
import formValidation from '@core/comp-functions/forms/form-validation';
import store from '@/store';
import vSelect from 'vue-select';
import { useRouter, showToast } from '@core/utils/utils';
import flatPickr from 'vue-flatpickr-component';
import { Vietnamese } from 'flatpickr/dist/l10n/vn';
import ScheduleView from './ScheduleView.vue';
export default {
  components: {
    BCol,
    BRow,
    BButton,
    BCard,
    BAlert,
    BFormGroup,
    BForm,
    BFormInput,
    BFormCheckbox,
    BFormTextarea,
    BLink,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    BTable,
    BOverlay,
    flatPickr,
    ScheduleView
  },
  data() {
    return {
      required,
      min,
      max,
      itemView: [],
      modal_title: 'Xem lại'
    };
  },
  setup(props, { emit }) {
    const { route, router } = useRouter();
    const itemsData = ref([])
    const dataChannel = ref([])
    const loading = ref(true)
    const frmData = ref({
      id: 0,
      name: '',
      date_play: 'news',
      channel_id: '',
      status: 0,
    });
    const id = route.value.params.id !== undefined ? route.value.params.id : 0;
    store.dispatch('schedule/edit', id)
      .then((response) => {
        const result = response.data;
        loading.value = false
        if (result.code === 200 && result.data) {
          frmData.value = result.data;
          itemsData.value = result.data.items
          dataChannel.value = result.data.channel
        }
      })

    const { refFormObserver, getValidationState, resetForm } = formValidation(frmData);
    const tableColumns = [
      { key: 'clockId', label: 'ID', thAttr: { width: '10%' }, thClass: 'text-center', tdClass: 'text-center' },
      { key: 'Frame', label: 'Khung giờ', thAttr: { width: '15%' } },
      { key: 'programFrames', label: 'Chương trình', },
      // { key: 'actions', label: 'Hành động', thAttr: { width: '10%' }, class: 'action', },
    ];
    const config_time = ref({
      dateFormat: 'Y-m-d',
      wrap: true,
      locale: Vietnamese, // locale for this instance only
    });
    return {
      refFormObserver,
      getValidationState,
      resetForm,
      tableColumns,
      frmData,
      itemsData,
      loading,
      config_time,
      dataChannel
    };
  },
  methods: {
    hidenView() {
      this.$bvModal.hide('modalView');
      this.itemView = {};
    },
    showView(item) {
      let urlPath = item.urlPath;
      item.type = 'application/x-mpegURL'
      let ext = urlPath.split('.').pop().toLowerCase();
      if (['mp3', 'wav'].includes(ext)) {
        item.type = 'audio/mpeg'
      } else if (['mp4'].includes(ext)) {
        item.type = 'video/mp4'
      }
      this.modal_title = 'Xem lại';
      this.itemView = item;
      this.$bvModal.show('modalView');
    },
    validationForm() {
      this.errorMessage = {}
      this.$refs.scheduleForm.validate().then(success => {
        if (success) {
          this.onSubmit();
        }
      })
    },
    onSubmit() {
      store
        .dispatch('schedule/update', { data: this.frmData, id: this.frmData.id })
        .then((response) => {
          const result = response.data;
          if (result.code === 200) {
            showToast(result.message, { variant: 'success' });
            this.$router.push({ name: 'schedule-list' })
          } else {
            showToast(result.message);
          }
        })
    },
  },
};
</script>

<style lang="scss">
.scheduleForm {
  .row {
    margin: 0 -0.5rem;

    .col-12 {
      padding: 0 0.5rem
    }
  }

  ul {
    padding: 0;
    margin: 0;

    li {
      display: flex;
      padding: 2px 0;

      span {
        &:hover {
          cursor: pointer;
          color: #ea5455
        }
      }
    }
  }
}

@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
